export const WEBSOCKET_MESSAGE_TYPES = {
  UPDATE: 'update',
  REMOVE: 'remove',
  ADD: 'add',
} as const;

export type WebSocketMessageType = (typeof WEBSOCKET_MESSAGE_TYPES)[keyof typeof WEBSOCKET_MESSAGE_TYPES];

export type BankFeedConnectionsHandleWebsocketPayload = {
  type: WebSocketMessageType;
  connectionIDs: string[];
};
